<div
  class="viewer-root"
  [class.viewer-root--embedded]="isComponent"
>
  <div class="viewer-viewport">
    @if (videoUrl) {
      <video
        class="viewer-video"
        [src]="videoUrl"
        controls
        playsinline
        preload="metadata"
      ></video>
    } @else {
      <div class="viewer-empty">{{ translations.noVideoAvailable }}</div>
    }
  </div>
</div>
